<template>
  <el-col :span="9">
    <el-container class="card">
      <router-link
        :to="{ name: `${path}` }"
        tag="span"
        class="card-link"
      >
        {{ cardMessage }}
      </router-link>
    </el-container>
  </el-col>
</template>

<script>
export default {
  name: 'BaseCard',
  props: {
    path: {
      type: String,
      default: '',
    },
    cardMessage: {
      type: String,
      default: '',
    },
  }
};
</script>
